<!-- =========================================================================================
  File Name: Customers.vue
  Description: Customers
========================================================================================== -->
<template>
	<div id="dashboard">
		<div class="vx-row">
      <!-- CARD 9: DISPATCHED ORDERS -->
      <div class="vx-col w-full">
        <vx-card title="Customers">
          <div slot="no-body" class="mt-4 ml-5 mr-5">
            <div id="data-list-list-view" class="data-list-container">
              <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="customers">

                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                  <!-- ITEMS PER PAGE -->
                  <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
                    <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                      <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ customers.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : customers.length }} of {{ queriedItems }}</span>
                      <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>
                    <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                    <vs-dropdown-menu>

                      <vs-dropdown-item @click="itemsPerPage=4">
                        <span>4</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="itemsPerPage=10">
                        <span>10</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="itemsPerPage=15">
                        <span>15</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="itemsPerPage=20">
                        <span>20</span>
                      </vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </div>

                <template slot="thead">
                  <vs-th sort-key="nursingHomeName">First Name</vs-th>
                  <vs-th sort-key="custName">Last Name</vs-th>
                  <vs-th sort-key="email">Email</vs-th>
                  <vs-th >Action</vs-th>

                </template>

                  <template slot-scope="{data}">
                    <tbody>
                      <vs-tr :data="customer" :key="indextr" v-for="(customer, indextr) in data">
                        <vs-td :data="customer.nursingHomeName">
                          <span>{{customer.firstName}}</span>
                        </vs-td>
                        <vs-td :data="customer.custName">
                          <span>{{customer.lastName}}</span>
                        </vs-td>
                        <vs-td :data="customer.email">
                          <span>{{customer.email}}</span>
                        </vs-td>
                        <vs-td :data="customer.path">
                          <vx-tooltip delay=".5s" text="View Albums">
                            <vs-button class="mr-1.5 shadow-lg" type="gradient" color="rgba(160, 97, 106, 0.8)" gradient-color-secondary="rgba(160, 97, 106, 0.8)" :to="{ name: 'customer-albums', params: { custID: customer.custID, firstName: customer.firstName, lastName: customer.lastName } }"><vs-icon icon="pageview" size="25px" color="white"></vs-icon></vs-button>
                          </vx-tooltip>
                        </vs-td>
                      </vs-tr>
                    </tbody>
                  </template>
              </vs-table>
            </div>
          </div>

        </vx-card>
      </div>
    </div>
	</div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'

export default{
  data () {
    return {
      customers:[],
      totalCustomers: 0,
      itemsPerPage: 4,
      isMounted: false,
      activeAPIMode: false
    }
  },
  components: {
    VueApexCharts,
    StatisticsCardLine
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.customers.length
    }
  },
  created () {

    this.$vs.loading()
    this.$http.get('/customers/')
      .then((response) => {
        this.totalCustomers = response.data.data[0].totalCustomers
        this.customers = response.data.customers
      })
      .catch((error)   => {
        this.$vs.loading.close()
        console.log(error)
        this.$vs.notify({title:'Something went wrong!', text:'Please try after some time.', color:'warning', position:'top-right', icon:'error', time:5000})
      })

    this.getAPIMode()
  },
  mounted () {
    this.isMounted = true

  },
  methods: {
    getAPIMode () {
      this.$http.get('/switch-mode/')
        .then((response) => {
          this.$vs.loading.close()
          if (response.data.data[0].env == 'dev') {
            this.activeAPIMode = false
          } else { this.activeAPIMode = true }
          this.$vs.loading.close()
        })
        .catch((error)   => {
          this.$vs.loading.close()
          console.log(error)
          this.$vs.notify({title:'Something went wrong!', text:'Unable to find Printer API mode.', color:'warning', position:'top-right', icon:'error', time:5000})
        })
    }
  },
  watch: {
    activeAPIMode (newValue) {
      //called whenever activeAPIMode changes
      this.$vs.loading()
      const formData = new FormData()
      if (newValue == true) {
        var new_mode = 'prod'
      } else {
        var new_mode = 'dev'
      }
      formData.append('env', new_mode)
      this.$http.post('/switch-mode/ ', formData, { headers: {'Content-Type': 'multipart/form-data' }})
        .then((response) => {
          this.$vs.loading.close()
          if (response.data.messageType == 'success') {
            this.$vs.notify({title:'Great!', text:'Api Mode changed', color:'success', position:'top-right', icon:'check_box', time:5000})
          } else {
            this.$vs.notify({title:'Attention!', text:response.data.message, color:'warning', position:'top-right', icon:'error', time:5000})
          }
        })
        .catch((error)   => {
          this.$vs.loading.close()
          console.log(error)
          this.$vs.notify({title:'Something went wrong!', text:'Please try after some time.', color:'warning', position:'top-right', icon:'error', time:5000})
        })

    }
  }


}
</script>
<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;
      font-size: 0.8rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }

  }

}
</style>
